import { PROCESS } from "@/data/content";
import { Reveal } from "./Reveal";

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-32 px-6 md:px-10 bg-forest text-cream relative overflow-hidden" data-testid="process-section">
      <div className="absolute inset-0 grain opacity-[0.04] pointer-events-none" />
      <div className="max-w-7xl mx-auto relative">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Notre méthode</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-normal tracking-tight leading-[1.1]">
              Un parcours simple et rassurant
            </h2>
          </div>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-2 gap-x-16 gap-y-16">
          {PROCESS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.n} delay={i * 0.1}>
                <div className="relative pl-2" data-testid={`process-step-${i}`}>
                  <div className="font-cormorant text-7xl md:text-8xl text-gold/25 leading-none absolute -top-8 -left-3 select-none">{p.n}</div>
                  <div className="relative pt-6">
                    <div className="w-12 h-12 rounded-2xl bg-cream/8 border border-gold/20 flex items-center justify-center mb-5">
                      <Icon className="w-6 h-6 text-gold" strokeWidth={1.5} />
                    </div>
                    <h3 className="font-cormorant text-2xl md:text-3xl font-medium text-cream">{p.title}</h3>
                    <p className="mt-3 text-cream/65 leading-relaxed max-w-md">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
